<template>
  <w-modal
    :value="value"
    @close="close"
    @input="$emit('input')"
  >
    <template #header>
      <h1 class="text-2xl text-center">
        選購不同的訂購？
      </h1>
    </template>
    <p class="text-black text-xl">
      您的購物車已包含「<b>{{ oriName }}</b>」的品項。您是否想要清空購物車，改成新增「<b>{{ curName }}</b>」的這份品項？
    </p>
    <template #footer>
      <div class="flex items-center justify-end">
        <w-button
          class="mr-6"
          variant="outline"
          @click="close"
        >
          取消
        </w-button>
        <w-button @click="clear">
          繼續選購
        </w-button>
      </div>
    </template>
  </w-modal>
</template>

<script>
import ClearCartDialog from './ClearCartDialog';

export default ClearCartDialog;
</script>

<style lang="scss" scoped>
@import 'ClearCartDialog';
</style>
